import { useExamCenter } from '@exam-center/exam-center-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Link } from '@exam-center/router';
import { AddRoundedIcon, Button, type ButtonProps } from '@shared/components';
import { WithPermission } from '@shared/permissions';

type ProctorRequestCreationButtonProps = Pick<ButtonProps, 'variant' | 'size'>;

export default function ProctorRequestCreationButton(
  props: Readonly<ProctorRequestCreationButtonProps>,
) {
  const { variant, size } = props;

  const { examCenter } = useExamCenter();

  return (
    <WithPermission
      requiredPermission={[APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.CREATE]}
    >
      <Button
        startIcon={<AddRoundedIcon />}
        component={Link}
        to='/:examCenterCode/exam-proctors/requests/create'
        params={{ examCenterCode: examCenter.code }}
        variant={variant}
        size={size}
      >
        สร้างคำขออนุมัติ
      </Button>
    </WithPermission>
  );
}
